export default __webpack_public_path__ + "static/media/settings.c89ab9be.svg";